import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './index.css';
import echo from '@/utils/echo';
import Toast from 'vue-toastification';
import Popper from 'vue3-popper';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';
import VOtpInput from 'vue3-otp-input';
import VuePapaParse from 'vue-papa-parse';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

//custom tooltip component
import './assets/tooltip/tooltip.css';
import tooltip from './assets/tooltip/tooltip.js';

//custom select input
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
initializeApp(firebaseConfig);

const app = createApp(App);
app.config.globalProperties.$echo = echo;

app
  .use(store)
  .use(router)
  .use(Toast)
  .use(VuePapaParse)
  .component('v-otp-input', VOtpInput)
  .component('VueDatePicker', VueDatePicker)
  .component('v-select', vSelect)
  .component('Popper', Popper)
  .directive('tooltip', tooltip)
  .mount('#app');
